import { ReactElement, memo } from 'react';
import { IComponentCss } from '@tap/mui-ui';
import { Tooltip, Grid } from '@mui/material';

/**
 *   Клетка в табилце с двумя значениями
 */

type ICellWithTwoValues = {
    /** Значение в первой строке */
    primaryValue?: number | string | React.ReactElement,

    /** Тулти для первой строки */
    primaryValueTooltip?: string | React.ReactElement,

    /** Значение во второй строке */
    secondaryValue?: number | string | null | React.ReactElement,

    /** Тулти для второго значения */
    secondaryValueTooltip?: string | React.ReactElement,

    /** Скрывать прочерки в полностью пустых клетках */
    isHideEmptyCellValue?: boolean,

    /** Выравнивать контент ячейки по правому краю (по умолчанию: false) */
    isRightAlign?: boolean,
    emptySecondaryValueCharacter?: string | null,
}


const css: IComponentCss = {
    cell: {
        minHeight: '38px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    secondaryValue: { color: '#999999' },
};


const CellWithTwoValuesSimple = ({
    primaryValue,
    primaryValueTooltip,
    secondaryValue,
    secondaryValueTooltip,
    isRightAlign,
    isHideEmptyCellValue = true,
    emptySecondaryValueCharacter = '-',
}: ICellWithTwoValues): ReactElement<any, any> => {

    return (
        (isHideEmptyCellValue && !primaryValue && !secondaryValue)
            ? <></>
            : <Grid
                item
                container
                justifyContent='center'
                alignItems='center'
                sx={{
                    ...css.cell,
                    justifyContent: isRightAlign ? 'flex-end' : 'flex-start',
                }}
            >
                <Tooltip
                    title={primaryValueTooltip}
                    disableHoverListener={!primaryValueTooltip}
                >
                    <span>
                        {primaryValue ?? '—'}
                    </span>
                </Tooltip>
                {(!!secondaryValue || !!emptySecondaryValueCharacter) && (
                    <>
                        <br />
                        <Grid
                            container
                            sx={{
                                ...css.secondaryValue,
                                justifyContent: isRightAlign ? 'flex-end' : 'flex-start',
                            }}
                        >
                            <Tooltip
                                title={secondaryValueTooltip}
                                disableHoverListener={!secondaryValueTooltip}
                            >
                                <span>{secondaryValue ?? emptySecondaryValueCharacter}</span>
                            </Tooltip>
                        </Grid>
                    </>
                )}
            </Grid>
    );
};


export const CellWithTwoValues = memo(
    CellWithTwoValuesSimple,
    (prevProps, nextProps) => {
        return prevProps.primaryValue === nextProps.primaryValue
            && prevProps.secondaryValue === nextProps.secondaryValue;
    },
);